// Keep the texts in sync with backend/api-server/src/lib/figma/figma-messages.ts.
import type { FigmaClientErrorCode } from "./api/figma-api";

/** Codes only an owner or admin can fix, in the project's integrations. */
export function isFigmaSetupCode(code: FigmaClientErrorCode | null | undefined): boolean {
  return code === "figma_not_configured" || code === "figma_reconnect_required";
}

/** Kairo's sentence for a Figma context error code (never Figma's own text). */
export function figmaErrorMessage(code: FigmaClientErrorCode): string {
  switch (code) {
    case "figma_not_configured":
      return "Figma is not connected to this project. An owner or admin must connect it in the project's integrations.";
    case "figma_reconnect_required":
      return "The Figma connection has expired or was revoked. An owner or admin must disconnect and connect Figma again in the project's integrations.";
    case "figma_forbidden":
      return "The connected Figma account cannot open this design.";
    case "figma_target_unavailable":
      return "Figma could not find this design, or it is no longer shared.";
    case "figma_rate_limited":
      return "Figma is limiting requests right now. Try again later.";
    case "unsupported_figma_url":
      return "This link is not a Figma design file or frame that Kairo can import.";
    case "forbidden":
      return "You are not a member of this project.";
    case "not_found":
      return "This Figma import no longer exists.";
    case "live_writes_unavailable":
      return "Kairo cannot update documents right now. Try again later.";
    case "network_error":
      return "Kairo could not be reached. Check your connection and try again.";
    case "invalid_request":
    case "figma_import_failed":
      return "Kairo could not import this design from Figma. Try again.";
    default: {
      const unknownCode: never = code;
      return unknownCode;
    }
  }
}
